import * as React from 'react'

function SvgJp(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h900v600H0z" />
			<circle fill="#bc002d" cx={450} cy={300} r={180} />
		</svg>
	)
}

export default SvgJp
